export const TITLES = {
  "en-GB": "Sitemap",
  "es-ES": "Mapa del sitio",
  "fr-FR": "Plan du site",
  "de-DE": "Sitemap",
  "it-IT": "Mappa del sito",
  "nl-NL": "Sitemap",
  "sv-SE": "Webbplatskarta ",
  "da-DK": "Sitemap",
  "pl-PL": "Mapa strony",
  "en-AU": "Sitemap",
  "en-US": "Sitemap",
};
